import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {PriceIncreaseFlexService} from '../../../price-increase-flex/price-increase-flex.service';
import {AlertService} from '../../../../common/alert-service/alert.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'workflow-price-increase-flex-modal',
    templateUrl: './workflow-price-increase-flex-create-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowPriceIncreaseFlexCreateModalComponent implements OnInit {
  @Input() workflowId: number;

  form: UntypedFormGroup;
  errors: { [key: string]: any } = {};

  constructor(private fb: UntypedFormBuilder,
              private service: PriceIncreaseFlexService,
              private alertService: AlertService,
              private modalRef: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      increase: [null, Validators.required],
    });
  }

  dismiss(): void {
    this.modalRef.dismiss();
  }

  submit(): void {
    this.errors = {};
    this.service.create(this.workflowId, this.form.value).subscribe(frame => {
      this.alertService.add('success', 'Flexibler Zuschlag wurde erfolgreich gespeichert');
      this.modalRef.close(frame);
    }, (errorResponse: HttpErrorResponse) => {
      if (errorResponse.error) {
        this.errors = errorResponse.error?.errors;
      }
    });
  }

}

